// extracted by mini-css-extract-plugin
module.exports = {"healthTitle":"Dashboard_healthTitle__1OnrS","healthList":"Dashboard_healthList__3I0Jc","offline":"Dashboard_offline__1f3RL","online":"Dashboard_online__1cI2h"};